import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Process } from '../../components/process/process';
import { ProcessForm } from './production-site-merge-types';
import { useProductionSiteMerge } from './production-site-merge-hook';
import { TranslationKeys } from '../../enums';

const useStyles = makeStyles(() =>
  createStyles({
    loaderWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      padding: '10px',
    },
  })
);

export function ProductionSiteMerge() {
  const classes = useStyles();

  const { steps, isLoading } = useProductionSiteMerge();

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress />
    </div>
  ) : (
    <Process<ProcessForm>
      title="Sloučení průmyslového místa"
      steps={steps}
      translationKey={TranslationKeys.PRODUCTION_SITE_MERGE}
    />
  );
}
